// extracted by mini-css-extract-plugin
module.exports = {"modal":"SideModal_modal__242TC","modal__backDrop":"SideModal_modal__backDrop__2gZ2c","modal__content":"SideModal_modal__content__3kNH2"};